module.exports = "<ul v-bind:class=\"{'nav': true, 'nav-stacked': vertical, 'nav-pills': type == 'pills', 'navbar-nav': type == 'navbar' }\">\n  <slot></slot> \n</ul>";


//////////////////
// WEBPACK FOOTER
// ./src/components/nav/nav.html
// module id = 60
// module chunks = 0